import { createContext } from "react";

interface DesktopBridgeRoomContextType {
  __ctx_init: boolean;
  room: string;
}

export const DesktopBridgeRoomContext =
  createContext<DesktopBridgeRoomContextType>({
    __ctx_init: false,
    room: "",
  });
